import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

type Props = { API: string };
const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
const errOf = (e: any, d: string) => (e && e.response && e.response.data && e.response.data.detail) || d;
const inp: any = { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit' };
const lab: any = { fontSize: 12, color: '#374151', marginBottom: 4, display: 'block', fontWeight: 600 };
const btn: any = { padding: '7px 14px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 13, cursor: 'pointer' };
const btnP: any = { ...btn, border: '1px solid #1d4ed8', background: '#1d4ed8', color: '#fff', fontWeight: 600 };
const box: any = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, marginBottom: 14 };
const LANGS: Array<[string, string]> = [['en', 'angielski'], ['cs', 'czeski'], ['sk', 'słowacki'], ['hu', 'węgierski'], ['de', 'niemiecki'],
  ['lt', 'litewski'], ['lv', 'łotewski'], ['et', 'estoński'], ['ro', 'rumuński'], ['bg', 'bułgarski'], ['fr', 'francuski'], ['it', 'włoski'],
  ['es', 'hiszpański'], ['nl', 'holenderski'], ['sv', 'szwedzki'], ['el', 'grecki'], ['uk', 'ukraiński']];
const langName = (k: string) => { const f = LANGS.find((x) => x[0] === k); return f ? f[1] : k; };

const DEFAULT_BODY = `Witaj {imie_nazwisko},

Dziękujemy za złożenie i opłacenie zamówienia.
Wiadomość generowana automatycznie, prosimy nie odpowiadać.

Zamówienie dotyczy produktów:
{produkty}

e-Paragon lub fakturę wysyłamy emailem w osobnej wiadomości email.

[przelew]Jeśli wybrałeś płatność przelewem, poniżej są dane do przelewu:
Fundacja SWT
A. Mickiewicza 66
15-213 Białystok
Nr konta: PL 93 1050 1953 1000 0090 3167 8973
tytułem: {nr_zamowienia}
kwota: {kwota} {waluta}
[/przelew]
Pozdrawiamy serdecznie,
motoLEDy
Wiadomość wygenerowana automatycznie przez OPENKontakt - inteligentna obsługa klienta dla sprzedawców Allegro.`;

const EMPTY = { name: 'Przyjęcie zamówienia', enabled: false, status_id: null as any, groups: ['allegro_pl', 'allegro_foreign', 'manual'], payment: 'any', occurrence: 'first', subject: 'Zamówienie {nr_zamowienia} zostało przyjęte', body: DEFAULT_BODY };

const FOOTER = `Pozdrawiamy serdecznie,
motoLEDy
Wiadomość wygenerowana automatycznie przez OPENKontakt - inteligentna obsługa klienta dla sprzedawców Allegro.`;
const SHIP_BODY = `Witaj {imie_nazwisko},

Twoje zamówienie {nr_zamowienia} zostało wysłane.
Wiadomość generowana automatycznie, prosimy nie odpowiadać.

Wysłane produkty:
{produkty}

Metoda dostawy: {metoda_dostawy}
Numer przesyłki: {nr_przesylki}
Śledzenie przesyłki:
{link_sledzenia}

` + FOOTER;
const RESEND_BODY = `Witaj {imie_nazwisko},

dosłaliśmy brakującą część Twojego zamówienia {nr_zamowienia}.
Wiadomość generowana automatycznie, prosimy nie odpowiadać.

Produkty w zamówieniu:
{produkty}

Numer przesyłki: {nr_przesylki}
Śledzenie przesyłki:
{link_sledzenia}

` + FOOTER;
const PRESETS: Array<[string, string, any]> = [
  ['accept', 'Przyjęcie zamówienia', {}],
  ['ship', 'Wysłanie zamówienia', { name: 'Wysłanie zamówienia', occurrence: 'first', subject: 'Zamówienie {nr_zamowienia} zostało wysłane', body: SHIP_BODY }],
  ['resend', 'Dosyłka', { name: 'Dosyłka', occurrence: 'repeat', subject: 'Dosłaliśmy część zamówienia {nr_zamowienia}', body: RESEND_BODY }],
  ['empty', 'Pusty', { name: 'Nowy szablon', subject: '', body: '' }],
];

function Msg({ m }: { m: any }) {
  if (!m) return null;
  const ok = m.ok === true, bad = m.ok === false;
  return <span style={{ fontSize: 13, fontWeight: 600, color: ok ? '#15803d' : (bad ? '#b91c1c' : '#6b7280') }}>{m.text}</span>;
}

export default function OrderMessagesSettings({ API }: Props) {
  const [d, setD] = useState<any>(null);
  const [statuses, setStatuses] = useState<any[]>([]);
  const [smtp, setSmtp] = useState<any>({ host: '', port: '465', login: '', password: '', sender_name: '' });
  const [smtpMsg, setSmtpMsg] = useState<any>(null);
  const [testTo, setTestTo] = useState('');
  const [car, setCar] = useState<any>({});
  const [carMsg, setCarMsg] = useState<any>(null);
  const [edit, setEdit] = useState<any>(null);
  const [editMsg, setEditMsg] = useState<any>(null);
  const [trLang, setTrLang] = useState('en');
  const [trEdit, setTrEdit] = useState<any>(null);
  const [pv, setPv] = useState<any>({ order: '', to: '', res: null, msg: null });
  const [loadErr, setLoadErr] = useState('');

  const load = () => {
    axios.get(API + '/settings/order-emails', { headers: auth() })
      .then((r: any) => {
        setD(r.data); setLoadErr('');
        const sm = r.data.smtp || {};
        setSmtp({ host: sm.host || '', port: sm.port || '465', login: sm.login || '', password: '', sender_name: sm.sender_name || '' });
        const m: any = {}; (r.data.carriers || []).forEach((c: any) => { m[c.carrier_id] = c.url || ''; }); setCar(m);
      })
      .catch((e: any) => setLoadErr(errOf(e, 'Nie udało się wczytać ustawień wiadomości.')));
    axios.get(API + '/orders/statuses', { headers: auth() }).then((r: any) => setStatuses((r.data && r.data.statuses) || [])).catch(() => setStatuses([]));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [API]);

  const stName = (id: any) => { const s = statuses.find((x: any) => x.id === id); return s ? s.name : (id ? 'status #' + id : '— brak —'); };

  const saveSmtp = () => {
    setSmtpMsg({ ok: null, text: '⏳ Zapisywanie…' });
    axios.post(API + '/settings/order-emails/smtp', smtp, { headers: auth() })
      .then((r: any) => { setD(r.data); setSmtp((p: any) => ({ ...p, password: '' })); setSmtpMsg({ ok: true, text: '✓ Zapisano skrzynkę.' }); })
      .catch((e: any) => setSmtpMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zapisać.') }));
  };
  const testSmtp = () => {
    setSmtpMsg({ ok: null, text: '⏳ Wysyłanie testu…' });
    axios.post(API + '/settings/order-emails/smtp/test', { to: testTo }, { headers: auth() })
      .then((r: any) => setSmtpMsg({ ok: !!r.data.ok, text: (r.data.ok ? '✓ ' : '✕ ') + r.data.message }))
      .catch((e: any) => setSmtpMsg({ ok: false, text: '✕ ' + errOf(e, 'Test nieudany.') }));
  };
  const delSmtp = () => {
    if (!window.confirm('Usunąć skrzynkę do wysyłek? Automat przestanie wysyłać wiadomości.')) return;
    axios.delete(API + '/settings/order-emails/smtp', { headers: auth() }).then(() => { setSmtpMsg({ ok: true, text: '✓ Usunięto skrzynkę.' }); load(); })
      .catch((e: any) => setSmtpMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się usunąć.') }));
  };
  const saveCar = () => {
    setCarMsg({ ok: null, text: '⏳ Zapisywanie…' });
    axios.post(API + '/settings/order-emails/carriers', car, { headers: auth() })
      .then(() => setCarMsg({ ok: true, text: '✓ Zapisano linki.' }))
      .catch((e: any) => setCarMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zapisać.') }));
  };

  const scrollEditor = () => window.setTimeout(() => { const el = document.getElementById('oe-editor'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
  const newFromPreset = (key: string) => {
    const p = PRESETS.find((x) => x[0] === key);
    const base: any = { ...EMPTY, groups: EMPTY.groups.slice(), ...((p && p[2]) || {}) };
    if (key === 'ship' || key === 'resend') {
      const st = statuses.find((x: any) => String(x.name || '').toLowerCase().replace('ł', 'l').indexOf('wysl') === 0);
      if (st) base.status_id = st.id;
    }
    openEdit(base);
    setEditMsg({ ok: null, text: 'Nowy szablon „' + base.name + '” (niezapisany)' + ((key === 'ship' || key === 'resend') && !base.status_id ? ' — wybierz status wysłania z listy.' : ' — sprawdź ustawienia i kliknij „Zapisz szablon”.') });
  };
  const openEdit = (t: any) => { setEdit(t ? JSON.parse(JSON.stringify(t)) : { ...EMPTY, groups: EMPTY.groups.slice() }); setEditMsg(null); setTrEdit(null); setPv({ order: '', to: '', res: null, msg: null }); scrollEditor(); };
  const copyTpl = () => {
    setEdit({ name: edit.name + ' (kopia)', enabled: false, status_id: edit.status_id, groups: (edit.groups || []).slice(), payment: edit.payment, occurrence: edit.occurrence, subject: edit.subject, body: edit.body });
    setEditMsg({ ok: null, text: 'To jest kopia (jeszcze niezapisana) — zmień nazwę i ustawienia, potem kliknij „Zapisz szablon”.' });
    setTrEdit(null); setPv({ order: '', to: '', res: null, msg: null }); scrollEditor();
  };
  const setE = (k: string, v: any) => setEdit((p: any) => ({ ...p, [k]: v }));
  const payload = (e: any) => ({ name: e.name, enabled: !!e.enabled, status_id: e.status_id ? Number(e.status_id) : null, groups: e.groups, payment: e.payment, occurrence: e.occurrence, subject: e.subject, body: e.body });
  const saveTpl = () => {
    setEditMsg({ ok: null, text: '⏳ Zapisywanie…' });
    const req = edit.id ? axios.put(API + '/settings/order-emails/templates/' + edit.id, payload(edit), { headers: auth() })
      : axios.post(API + '/settings/order-emails/templates', payload(edit), { headers: auth() });
    req.then((r: any) => { setEdit(r.data); setEditMsg({ ok: true, text: '✓ Zapisano szablon.' }); load(); })
      .catch((e: any) => setEditMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zapisać szablonu.') }));
  };
  const delTpl = () => {
    if (!edit.id || !window.confirm('Usunąć szablon „' + edit.name + '”?')) return;
    axios.delete(API + '/settings/order-emails/templates/' + edit.id, { headers: auth() }).then(() => { setEdit(null); load(); })
      .catch((e: any) => setEditMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się usunąć.') }));
  };
  const translate = () => {
    setEditMsg({ ok: null, text: '⏳ Tłumaczenie na ' + langName(trLang) + '…' });
    axios.post(API + '/settings/order-emails/templates/' + edit.id + '/translate/' + trLang, {}, { headers: auth() })
      .then((r: any) => { setEdit(r.data); setEditMsg({ ok: true, text: '✓ Przetłumaczono na ' + langName(trLang) + '.' }); })
      .catch((e: any) => setEditMsg({ ok: false, text: '✕ ' + errOf(e, 'Tłumaczenie nie powiodło się.') }));
  };
  const saveTr = () => {
    setEditMsg({ ok: null, text: '⏳ Zapisywanie tłumaczenia…' });
    axios.put(API + '/settings/order-emails/templates/' + edit.id + '/translations/' + trEdit.lang, { subject: trEdit.subject, body: trEdit.body }, { headers: auth() })
      .then((r: any) => { setEdit(r.data); setTrEdit(null); setEditMsg({ ok: true, text: '✓ Zapisano tłumaczenie.' }); })
      .catch((e: any) => setEditMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zapisać tłumaczenia.') }));
  };
  const delTr = (lang: string) => {
    axios.delete(API + '/settings/order-emails/templates/' + edit.id + '/translations/' + lang, { headers: auth() })
      .then((r: any) => { setEdit(r.data); setTrEdit(null); })
      .catch((e: any) => setEditMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się usunąć tłumaczenia.') }));
  };
  const preview = (send: boolean) => {
    setPv((p: any) => ({ ...p, msg: { ok: null, text: send ? '⏳ Wysyłanie…' : '⏳ Przygotowanie podglądu…' } }));
    axios.post(API + '/settings/order-emails/preview', { template_id: edit.id, order_number: pv.order, send_to: send ? pv.to : null }, { headers: auth() })
      .then((r: any) => setPv((p: any) => ({ ...p, res: r.data, msg: { ok: true, text: r.data.sent ? '✓ Wysłano na ' + r.data.sent_to + '.' : '✓ Podgląd gotowy.' } })))
      .catch((e: any) => setPv((p: any) => ({ ...p, msg: { ok: false, text: '✕ ' + errOf(e, 'Nie udało się.') } })));
  };

  if (loadErr) return <div style={{ ...box, color: '#b91c1c' }}>{loadErr}</div>;
  if (!d) return <div style={{ fontSize: 13, color: '#6b7280' }}>Wczytywanie…</div>;
  const G = d.groups || {}, P = d.payments || {}, OC = d.occurrences || {};

  return (
    <div style={{ maxWidth: 900 }}>
      {/* --- skrzynka --- */}
      <div style={box}>
        <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 6 }}>Skrzynka do wysyłek wiadomości o zamówieniach</div>
        <div style={{ background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', borderRadius: 8, padding: '8px 12px', fontSize: 13, marginBottom: 12 }}>
          ⚠️ Ten adres e-mail musi być dodany w Allegro do <b>zaufanych adresów e-mail</b> — inaczej wiadomość nie dotrze do kupującego z Allegro.
        </div>
        {d.queue ? (
          <div style={{ fontSize: 12, color: '#374151', marginBottom: 10 }}>
            Wysłane w ostatnich 24 h: <b>{d.queue.sent_24h}</b>
            {d.queue.limited ? <span style={{ color: '#b45309' }}> · w kolejce (limit skrzynki): <b>{d.queue.limited}</b></span> : null}
            {d.queue.waiting_shipment ? <span> · czeka na nr przesyłki: <b>{d.queue.waiting_shipment}</b></span> : null}
            {d.queue.pause_until ? <span style={{ color: '#b91c1c' }}> · wysyłka wstrzymana do <b>{new Date(d.queue.pause_until).toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit' })}</b> (skrzynka przekroczyła limit — automat ponowi sam)</span> : null}
          </div>
        ) : null}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 10, marginBottom: 10 }}>
          <div><label style={lab}>Serwer SMTP</label><input value={smtp.host} onChange={(e: any) => setSmtp({ ...smtp, host: e.target.value })} placeholder="np. smtp.twojadomena.pl" style={inp} /></div>
          <div><label style={lab}>Port</label>
            <select value={smtp.port} onChange={(e: any) => setSmtp({ ...smtp, port: e.target.value })} style={inp}>
              <option value="465">465 (SSL)</option><option value="587">587 (STARTTLS)</option>
            </select></div>
          <div><label style={lab}>Login = adres nadawcy</label><input value={smtp.login} onChange={(e: any) => setSmtp({ ...smtp, login: e.target.value })} placeholder="zamowienia@twojadomena.pl" autoComplete="off" style={inp} /></div>
          <div><label style={lab}>Hasło {d.smtp.password_saved ? <span style={{ fontWeight: 400, color: '#15803d' }}>(zapisane)</span> : null}</label><input type="password" value={smtp.password} onChange={(e: any) => setSmtp({ ...smtp, password: e.target.value })} placeholder={d.smtp.password_saved ? '••••••••' : ''} autoComplete="new-password" style={inp} /></div>
          <div><label style={lab}>Nazwa nadawcy</label><input value={smtp.sender_name} onChange={(e: any) => setSmtp({ ...smtp, sender_name: e.target.value })} placeholder="np. motoLEDy" style={inp} /></div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <button onClick={saveSmtp} style={btnP}>Zapisz skrzynkę</button>
          {d.smtp.configured ? <>
            <input value={testTo} onChange={(e: any) => setTestTo(e.target.value)} placeholder="adres do testu" style={{ ...inp, width: 220 }} />
            <button onClick={testSmtp} style={btn}>Wyślij test</button>
            <button onClick={delSmtp} style={{ ...btn, color: '#b91c1c', borderColor: '#fecdd3' }}>Usuń</button>
          </> : null}
          <Msg m={smtpMsg} />
        </div>
      </div>

      {/* --- szablony --- */}
      <div style={box}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
          <div style={{ fontWeight: 700, fontSize: 15, flex: 1 }}>Szablony wiadomości</div>
          {edit && edit.id ? <button onClick={copyTpl} style={{ ...btn, marginRight: 8 }}>⧉ Kopiuj jako nowy</button> : null}
          <select value="" onChange={(e: any) => { if (e.target.value) newFromPreset(e.target.value); }} style={{ ...btnP, padding: '7px 10px' }}>
            <option value="">＋ Nowy szablon…</option>
            {PRESETS.map((p) => <option key={p[0]} value={p[0]}>{p[1]}</option>)}
          </select>
        </div>
        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>
          Wiadomość wysyła się automatycznie, gdy zamówienie wejdzie w wybrany status (sprawdzane co 2 minuty). Przy każdym wejściu w status idzie jedna wiadomość — z najlepiej pasującego szablonu.
          Treść piszesz po polsku; do klientów zagranicznych szablon jest tłumaczony raz na ich język i zapisywany.
        </div>
        {(
          (d.templates || []).length === 0 ? <div style={{ fontSize: 13, color: '#6b7280' }}>Brak szablonów.</div> : (
            <div>
              {(d.templates || []).map((t: any) => (
                <div key={t.id} onClick={() => openEdit(t)} style={{ display: 'flex', gap: 10, alignItems: 'center', background: edit && edit.id === t.id ? '#eff6ff' : '#fff', border: '1px solid ' + (edit && edit.id === t.id ? '#93c5fd' : '#e5e7eb'), borderRadius: 8, padding: '8px 12px', marginBottom: 8, cursor: 'pointer' }}>
                  <span style={{ fontSize: 11, fontWeight: 700, borderRadius: 999, padding: '2px 8px', color: t.enabled ? '#15803d' : '#6b7280', background: t.enabled ? '#f0fdf4' : '#f3f4f6', border: '1px solid ' + (t.enabled ? '#bbf7d0' : '#e5e7eb') }}>{t.enabled ? 'WŁĄCZONY' : 'wyłączony'}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>{t.name}</div>
                    <div style={{ fontSize: 12, color: '#6b7280' }}>status: <b>{stName(t.status_id)}</b> · {(t.groups || []).map((g: string) => G[g] || g).join(', ')} · płatność: {P[t.payment]} · {OC[t.occurrence]}{Object.keys(t.translations || {}).length ? ' · tłumaczenia: ' + Object.keys(t.translations).join(', ') : ''}</div>
                  </div>
                  <span style={{ color: '#9ca3af', fontSize: 18 }}>›</span>
                </div>
              ))}
            </div>
          )
        )}
        {edit ? (
          <div id="oe-editor" style={{ border: '2px solid #93c5fd', background: '#f8fbff', borderRadius: 10, padding: 14, marginTop: 12 }}>
            <div style={{ fontWeight: 700, fontSize: 14, color: '#1d4ed8', marginBottom: 10 }}>{edit.id ? '✏️ Edycja szablonu: ' + edit.name : '＋ Nowy szablon (niezapisany)'}</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 10, marginBottom: 10 }}>
              <div><label style={lab}>Nazwa szablonu</label><input value={edit.name} onChange={(e: any) => setE('name', e.target.value)} style={inp} /></div>
              <div><label style={lab}>Wysyłaj, gdy zamówienie wejdzie w status</label>
                <select value={edit.status_id || ''} onChange={(e: any) => setE('status_id', e.target.value ? Number(e.target.value) : null)} style={inp}>
                  <option value="">— wybierz status —</option>
                  {statuses.map((s: any) => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select></div>
              <div><label style={lab}>Płatność</label>
                <select value={edit.payment} onChange={(e: any) => setE('payment', e.target.value)} style={inp}>
                  {Object.keys(P).map((k) => <option key={k} value={k}>{P[k]}</option>)}
                </select></div>
              <div><label style={lab}>Które wejście w status</label>
                <select value={edit.occurrence} onChange={(e: any) => setE('occurrence', e.target.value)} style={inp}>
                  {Object.keys(OC).map((k) => <option key={k} value={k}>{OC[k]}</option>)}
                </select></div>
            </div>
            <label style={lab}>Grupy klientów</label>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 10 }}>
              {Object.keys(G).map((g) => (
                <label key={g} style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
                  <input type="checkbox" checked={(edit.groups || []).indexOf(g) >= 0}
                    onChange={(e: any) => setE('groups', e.target.checked ? (edit.groups || []).concat([g]) : (edit.groups || []).filter((x: string) => x !== g))} /> {G[g]}
                </label>
              ))}
            </div>
            <label style={lab}>Temat (po polsku)</label>
            <input value={edit.subject} onChange={(e: any) => setE('subject', e.target.value)} style={{ ...inp, marginBottom: 10 }} />
            <label style={lab}>Treść (po polsku)</label>
            <textarea value={edit.body} onChange={(e: any) => setE('body', e.target.value)} rows={16} style={{ ...inp, resize: 'vertical', fontFamily: 'monospace', fontSize: 12.5 }} />
            <div style={{ fontSize: 12, color: '#374151', margin: '6px 0 10px', lineHeight: 1.5 }}>
              Zmienne: {(d.vars || []).map((v: string) => <code key={v} style={{ background: '#eef2ff', borderRadius: 4, padding: '0 4px', marginRight: 4 }}>{'{' + v + '}'}</code>)}<br />
              Tekst między <code>[przelew]</code> a <code>[/przelew]</code> pojawi się tylko przy płatności przelewem.
            </div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginBottom: 6 }}>
              <label style={{ fontSize: 13, fontWeight: 600, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
                <input type="checkbox" checked={!!edit.enabled} onChange={(e: any) => setE('enabled', e.target.checked)} /> Szablon włączony (wysyła wiadomości)
              </label>
              <span style={{ flex: 1 }} />
              <button onClick={() => setEdit(null)} style={btn}>Zamknij</button>
              {edit.id ? <button onClick={delTpl} style={{ ...btn, color: '#b91c1c', borderColor: '#fecdd3' }}>Usuń</button> : null}
              <button onClick={saveTpl} style={btnP}>Zapisz szablon</button>
            </div>
            <div style={{ minHeight: 20 }}><Msg m={editMsg} /></div>

            {edit.id ? (
              <div style={{ borderTop: '1px solid #dbeafe', marginTop: 10, paddingTop: 10 }}>
                <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 6 }}>Tłumaczenia</div>
                <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8 }}>Tworzą się same przy pierwszej wiadomości w danym języku. Możesz je przygotować wcześniej i poprawić. Po zmianie polskiej treści tłumaczenie jest oznaczane jako nieaktualne i automat przetłumaczy je ponownie.</div>
                {Object.keys(edit.translations || {}).map((k) => {
                  const t = edit.translations[k];
                  return (
                    <div key={k} style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 13, marginBottom: 4 }}>
                      <b style={{ minWidth: 90 }}>{langName(k)}</b>
                      <span style={{ color: t.stale ? '#b45309' : '#15803d', fontSize: 12 }}>{t.stale ? 'nieaktualne' : (t.manual ? 'poprawione ręcznie' : 'aktualne')}</span>
                      <span style={{ flex: 1 }} />
                      <button onClick={() => setTrEdit({ lang: k, subject: t.subject, body: t.body })} style={{ ...btn, padding: '3px 10px', fontSize: 12 }}>Pokaż / popraw</button>
                      <button onClick={() => delTr(k)} style={{ ...btn, padding: '3px 10px', fontSize: 12, color: '#b91c1c' }}>Usuń</button>
                    </div>
                  );
                })}
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 6 }}>
                  <select value={trLang} onChange={(e: any) => setTrLang(e.target.value)} style={{ ...inp, width: 180 }}>
                    {LANGS.map((l) => <option key={l[0]} value={l[0]}>{l[1]}</option>)}
                  </select>
                  <button onClick={translate} style={btn}>Przetłumacz teraz</button>
                </div>
                {trEdit ? (
                  <div style={{ marginTop: 10, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 10 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 6 }}>Tłumaczenie: {langName(trEdit.lang)}</div>
                    <input value={trEdit.subject} onChange={(e: any) => setTrEdit({ ...trEdit, subject: e.target.value })} style={{ ...inp, marginBottom: 6 }} />
                    <textarea value={trEdit.body} onChange={(e: any) => setTrEdit({ ...trEdit, body: e.target.value })} rows={12} style={{ ...inp, resize: 'vertical', fontFamily: 'monospace', fontSize: 12.5 }} />
                    <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                      <button onClick={() => setTrEdit(null)} style={btn}>Anuluj</button>
                      <button onClick={saveTr} style={btnP}>Zapisz tłumaczenie</button>
                    </div>
                  </div>
                ) : null}

                <div style={{ fontWeight: 600, fontSize: 13, margin: '14px 0 6px' }}>Podgląd i test na zamówieniu</div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                  <input value={pv.order} onChange={(e: any) => setPv({ ...pv, order: e.target.value })} placeholder="nr zamówienia, np. OK261004359" style={{ ...inp, width: 230 }} />
                  <button onClick={() => preview(false)} disabled={!pv.order.trim()} style={btn}>Podgląd</button>
                  <input value={pv.to} onChange={(e: any) => setPv({ ...pv, to: e.target.value })} placeholder="wyślij na mój adres" style={{ ...inp, width: 220 }} />
                  <button onClick={() => preview(true)} disabled={!pv.order.trim() || !pv.to.trim()} style={btn}>Wyślij test</button>
                  <Msg m={pv.msg} />
                </div>
                {pv.res ? (
                  <div style={{ marginTop: 8, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 10, fontSize: 13 }}>
                    <div style={{ color: '#6b7280', fontSize: 12, marginBottom: 6 }}>Zamówienie {pv.res.order_number} · grupa: {pv.res.group} · język: {langName(pv.res.lang) || pv.res.lang} · płatność: {pv.res.payment} · do: {pv.res.to || '— brak adresu —'}</div>
                    <div style={{ fontWeight: 700, marginBottom: 6 }}>{pv.res.subject}</div>
                    <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}>{pv.res.body}</pre>
                  </div>
                ) : null}
              </div>
            ) : <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>Tłumaczenia i podgląd będą dostępne po zapisaniu szablonu.</div>}
          </div>
        ) : null}
      </div>

      {/* --- linki sledzenia --- */}
      <div style={box}>
        <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 6 }}>Linki śledzenia przesyłek</div>
        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>Używane w zmiennej <code>{'{link_sledzenia}'}</code>. W miejsce <code>{'{nr}'}</code> wstawiany jest numer przesyłki. Wzory domyślne sprawdź na jednej przesyłce, zanim włączysz wysyłkę.</div>
        {Object.keys(car).map((k) => {
          const c = (d.carriers || []).find((x: any) => x.carrier_id === k);
          return (
            <div key={k} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
              <span style={{ minWidth: 150, fontSize: 13, fontWeight: 600 }}>{k}{c && c.count ? <span style={{ fontWeight: 400, color: '#6b7280' }}> ({c.count})</span> : null}</span>
              <input value={car[k]} onChange={(e: any) => setCar({ ...car, [k]: e.target.value })} placeholder="https://…{nr}" style={inp} />
            </div>
          );
        })}
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 6 }}>
          <button onClick={saveCar} style={btnP}>Zapisz linki</button>
          <Msg m={carMsg} />
        </div>
      </div>
    </div>
  );
}
